(function () {
  function closest(el, sel) {
    while (el && el !== document) {
      if (el.matches && el.matches(sel)) return el;
      el = el.parentNode;
    }
    return null;
  }

  function sectionsToRequest() {
    var list = [];
    if (document.getElementById('main-cart-items')) {
      list.push(document.getElementById('main-cart-items').dataset.id);
    }
    if (document.querySelector('cart-drawer')) {
      list.push('cart-drawer');
    }
    list.push('cart-icon-bubble');
    return list;
  }

  function cleanupOrphanModals() {
    document.querySelectorAll('body > modal-dialog.gift-note-modal').forEach(function (m) {
      m.parentNode.removeChild(m);
    });
  }

  function applyRenderedSections(parsed) {
    if (!parsed || !parsed.sections) return;
    cleanupOrphanModals();
    var mainCart = document.getElementById('main-cart-items');
    if (mainCart && parsed.sections[mainCart.dataset.id]) {
      var parsedDoc = new DOMParser().parseFromString(parsed.sections[mainCart.dataset.id], 'text/html');
      var src = parsedDoc.querySelector('.js-contents');
      var dest = mainCart.querySelector('.js-contents');
      if (src && dest) dest.innerHTML = src.innerHTML;
    }
    var drawer = document.getElementById('CartDrawer');
    if (drawer && parsed.sections['cart-drawer']) {
      var parsedDoc2 = new DOMParser().parseFromString(parsed.sections['cart-drawer'], 'text/html');
      var src2 = parsedDoc2.querySelector('.drawer__inner');
      var dest2 = drawer.querySelector('.drawer__inner');
      if (src2 && dest2) dest2.innerHTML = src2.innerHTML;
    }
    var bubble = document.getElementById('cart-icon-bubble');
    if (bubble && parsed.sections['cart-icon-bubble']) {
      var bubbleDoc = new DOMParser().parseFromString(parsed.sections['cart-icon-bubble'], 'text/html');
      var bsrc = bubbleDoc.querySelector('.shopify-section');
      if (bsrc) bubble.innerHTML = bsrc.innerHTML;
    }
  }

  function closeModal(modal) {
    if (!modal) return;
    var closeId = modal.getAttribute('data-modal-close-id');
    var closeBtn = closeId ? document.getElementById(closeId) : modal.querySelector('[id^="ModalClose-"]');
    if (closeBtn) closeBtn.click();
  }

  function save(modal) {
    var itemKey = modal.dataset.itemKey;
    var line = parseInt(modal.dataset.line, 10);
    var saveBtn = modal.querySelector('[data-gift-note-save]');
    var errorEl = modal.querySelector('[data-gift-note-error]');
    var otherEl = modal.querySelector('[data-gift-note-other-props]');
    var properties = {};

    if (otherEl) {
      try { properties = JSON.parse(otherEl.textContent) || {}; }
      catch (e) { properties = {}; }
    }

    modal.querySelectorAll('[data-gift-note-field]').forEach(function (field) {
      var name = field.getAttribute('data-gift-note-field');
      var val = field.value.trim();
      if (val) properties[name] = val;
    });

    if (saveBtn) saveBtn.disabled = true;
    if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }

    var payload = {
      properties: properties,
      sections: sectionsToRequest(),
      sections_url: window.location.pathname
    };
    if (line && !isNaN(line)) {
      payload.line = line;
    } else if (itemKey) {
      payload.id = itemKey;
    }

    fetch(window.routes.cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (!res.ok || res.data.status) {
          var msg = (res.data && (res.data.description || res.data.message)) || 'Unable to update gift note.';
          if (errorEl) { errorEl.textContent = msg; errorEl.hidden = false; }
          return;
        }
        closeModal(modal);
        applyRenderedSections(res.data);
        document.dispatchEvent(new CustomEvent('cart:change', { detail: { cart: res.data, source: 'gift-note-edit' } }));
      })
      .catch(function () {
        if (errorEl) { errorEl.textContent = 'Network error. Please try again.'; errorEl.hidden = false; }
      })
      .finally(function () {
        if (saveBtn) saveBtn.disabled = false;
      });
  }

  function populateFromCart(modal) {
    var line = parseInt(modal.dataset.line, 10);
    var itemKey = modal.dataset.itemKey;
    if (!line && !itemKey) return;
    fetch((window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '.js', {
      headers: { 'Accept': 'application/json' },
      credentials: 'same-origin'
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart || !Array.isArray(cart.items)) return;
        var item = null;
        if (itemKey) {
          for (var i = 0; i < cart.items.length; i++) {
            if (cart.items[i].key === itemKey) { item = cart.items[i]; break; }
          }
        }
        if (!item && line) item = cart.items[line - 1];
        if (!item) return;
        var props = item.properties || {};
        ['To', 'From', 'Note'].forEach(function (name) {
          var field = modal.querySelector('[data-gift-note-field="' + name + '"]');
          if (field) field.value = props[name] || '';
        });
        // Keep the modal's own item-key/line in sync, since key changes when properties change.
        modal.dataset.itemKey = item.key || '';
      })
      .catch(function () {});
  }

  document.addEventListener('click', function (e) {
    var saveEl = closest(e.target, '[data-gift-note-save]');
    if (saveEl) {
      e.preventDefault();
      var modal = closest(saveEl, '[data-gift-note-cart]');
      if (modal) save(modal);
      return;
    }

    var toggle = closest(e.target, '.gift-note-cart__toggle');
    if (toggle) {
      var opener = closest(toggle, 'modal-opener');
      var sel = opener && opener.getAttribute('data-modal');
      if (!sel) return;
      var modalEl = document.querySelector(sel);
      if (modalEl) populateFromCart(modalEl);
    }
  });

  // When the cart is updated by other flows (qty change, remove), the
  // re-rendered cart markup spawns fresh modal-dialog elements that move to
  // body on connect. Remove stale orphans whose source markup is gone.
  document.addEventListener('cart:change', function () {
    document.querySelectorAll('body > modal-dialog.gift-note-modal').forEach(function (m) {
      var id = m.id;
      // If another element with the same id already exists elsewhere (the new
      // clone before it reconnects), skip — connectedCallback will dedupe.
      var matchesInCart = document.querySelectorAll('#' + CSS.escape(id));
      if (matchesInCart.length > 1) {
        m.parentNode.removeChild(m);
      }
    });
  });
})();
